import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import content from "../../data/content.json";
import { multipropriedadeConfig } from "../../config/niches/multipropriedade";

export const ABOUT_MODULES: { id: string; title: string; to?: string }[] = [
  ...content.home.solutions.modules.filter((m) => m.to),
  { id: "multipropriedade", title: multipropriedadeConfig.name, to: `/${multipropriedadeConfig.slug}` },
  ...content.home.solutions.modules.filter((m) => !m.to),
];

export function AboutModules() {
  return (
    <section aria-labelledby="about-modules-title" className="mt-16">
      <h2 id="about-modules-title" className="text-base font-semibold text-slate-100 md:text-lg">Módulos</h2>
      <ul data-testid="about-modules" className="mt-6 grid gap-4 sm:grid-cols-2">
        {ABOUT_MODULES.map((m) => (
          <li key={m.id} className="flex items-center justify-between gap-4 rounded-md border border-slate-800 bg-slate-900 px-5 py-4">
            <span className="text-sm text-slate-200">{m.title}</span>
            {m.to ? (
              <Link to={m.to} data-testid={`about-module-${m.id}-link`} className="inline-flex shrink-0 items-center gap-1 text-sm font-medium text-emerald-400 transition-colors duration-200 hover:text-emerald-300">
                Acessar <ArrowRight aria-hidden="true" className="h-4 w-4" />
              </Link>
            ) : (
              <span data-testid={`about-module-${m.id}-soon`} className="shrink-0 font-mono text-xs uppercase text-slate-500">Em breve</span>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
